const SHERLOC_OUTPUT_HEADING_LIST_PREFIX =
  /^(?:(?:[-–—•*])|(?:[A-Z]\.)|(?:[0-9]+[.)]))\s+/i;

/**
 * Normalizes display text only after a line has entered SHERLOC's recognized
 * output-heading boundary. Body-copy lines must not pass through this helper.
 */
export const normalizeSherlocOutputSectionHeading = (value) =>
  String(value || "")
    .trim()
    .replace(SHERLOC_OUTPUT_HEADING_LIST_PREFIX, "")
    .replace(/[:：]\s*$/, "")
    .trim();

export default normalizeSherlocOutputSectionHeading;
